import React, { useEffect, useState } from 'react'
import "./TeamInnerHero.css"
import { useParams } from 'react-router-dom'
import { getBioById } from '../../TeamData'
import { getTeamData } from '../../screens/Team'

function TeamInnerHero() {
  const {id}  = useParams()

  const [teamData, setTeamData] = useState()
  const [teamBio, setTeamBio] = useState()

  useEffect(()=>{
    const getBio = ()=>{
        const fetchedData = getBioById(id)
        const fetchedMemberData = getTeamData(id)
        setTeamBio(fetchedData?.bio)
        setTeamData(fetchedMemberData)
    }

    getBio()
  },[id])

  return (
    <div className='TeamInnerHero-container standard-padding-space'>
        <div className='container'>
            <div className='row align-items-center gy-lg-0 gy-4'>
                <div className='col-lg-6'>
                    {/* <img src='/images/creatives/team-card-img-1.png' className='img-fluid w-75' alt='home banner' style={{borderRadius:"20px"}}/> */}
                    <img src={teamData?.img} className='img-fluid w-75' alt='home banner' style={{borderRadius:"20px"}}/>
                </div>
                <div className='col-lg-6 px-3'>
                    <div className='card-box p-4'>
                        {/* <h3 className='body-heading'>Dr. Fabio Varlese</h3>
                        <h6 className='sub-heading'>MD, FRCPC</h6> */}
                        <h3 className='body-heading'>{teamData?.name}</h3>
                        <h6 className='sub-heading'>{teamData?.rank}</h6>
                        <p className='body-paragraph' dangerouslySetInnerHTML={{__html:teamBio}}></p>
                        {/* <p className='body-paragraph'>
                            Dr. Fabio Varlese is a prominent Specialist in Internal Medicine and Geriatric Medicine. He
graduated Summa Cum Laude at the University of Rome, and later became a diplomat with
the American Board of Internal Medicine specializing in Internal Medicine at the Cleveland
Clinic Health System.
<br></br>
He then specialized in Geriatric Medicine at the University of Toronto and he is licenced to
practice medicine in Canada, Italy and the United States.
<br></br>
Dr. Varlese is the former Medical Program Director of the Rehabilitation Department and the
Acute Care Unit at Baycrest Health Sciences, where he oversaw the development of new
national standards of excellence in the care of the elders.
<br></br>
In addition to his current responsibilities as Staff Specialist at Baycrest Health Sciences and
Mt. Sinai Hospital, he is the Honorary Medical Director at Villa Colombo Vaughan and the VP
of Medical Affairs and Chief of Staff at Runnymede Hospital.
<br></br>
Dr. Varlese’s expertise in the fields of geriatric and acute care has inspired his interest in
preventative medicine
                        </p> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TeamInnerHero